import { sendToLurker } from '../../Lurker';
export const sendClickEvent = function (objectDetail) {
  let objectName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'footer';
  let data = arguments.length > 2 ? arguments[2] : undefined;
  sendToLurker({
    eventType: 'click',
    objectDetail,
    objectName,
    data: Object.assign({
      page_current: window.location.href
    }, data)
  });
};